let CLICK_OUTSIDE_HANDLER = '_clickoutside_handler'

export default {
  mounted(el, binding, vnode) {
    if (typeof binding.value !== 'function') {
      return
    }

    let init = false
    setTimeout(function () {
      init = true
    }, 0)

    el[CLICK_OUTSIDE_HANDLER] = function (event) {
      if (!init) return

      let target = event.target
      if (target.ownerSVGElement) {
        target = target.ownerSVGElement
      }

      let clickedInside = el === event.target || el.contains(event.target) || el.contains(target)

      if (!clickedInside && event.composedPath) {
        clickedInside = event.composedPath().includes(el)
      }

      if (!clickedInside) {
        let parent = event.target
        while (parent && parent !== document.documentElement) {
          if (parent === el) {
            clickedInside = true
            break
          }
          parent = parent.parentElement
        }
      }

      if (!clickedInside) {
        return binding.value.call(vnode.context, event)
      }
    }

    document.documentElement.addEventListener('click', el[CLICK_OUTSIDE_HANDLER], false)
  },

  unmounted(el) {
    document.documentElement.removeEventListener('click', el[CLICK_OUTSIDE_HANDLER], false)
    delete el[CLICK_OUTSIDE_HANDLER]
  },
}
